// groupActivityBursts.js

/**
 * Identity for consecutive burst grouping.
 *
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function getActivityBurstProjectKey(item) {
  const projectKey = String(item?.projectNode?.key || '').trim();
  if (projectKey) return projectKey;

  const label = String(item?.projectLabel || '').trim();
  if (label) return `label:${label}`;

  return String(item?.nodeKey || item?.key || '').trim();
}

/**
 * Groups a time-ordered feed into consecutive same-project bursts.
 * A new burst starts only when the project changes.
 *
 * @param {object[]} items
 * @returns {Array<{
 *   key: string,
 *   projectKey: string,
 *   projectLabel: string,
 *   projectNode: object|null,
 *   items: object[],
 * }>}
 */
export function groupActivityBursts(items) {
  const bursts = [];

  (Array.isArray(items) ? items : []).forEach((item) => {
    if (!item) return;

    const projectKey = getActivityBurstProjectKey(item);
    const last = bursts[bursts.length - 1];

    if (last && last.projectKey === projectKey) {
      last.items.push(item);
      return;
    }

    bursts.push({
      key: `${projectKey}:${item.key}`,
      projectKey,
      projectLabel: String(item.projectLabel || '').trim(),
      projectNode: item.projectNode || item.node || null,
      items: [item],
    });
  });

  return bursts;
}
